import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section data-section-id="222605" id="cart-content" className="bg-background text-foreground py-16 md:py-24 min-h-[60vh] flex flex-col items-center">
      <div className="container mx-auto px-4 max-w-6xl w-full">
        <header className="mb-12 text-center">
          <h1 className="font-default text-4xl md:text-6xl font-semibold text-primary mb-4 tracking-wider">
            Your Selection
          </h1>
          <p className="text-muted-foreground font-serif text-lg md:text-xl max-w-2xl mx-auto italic">
            Review your curated collection of estate-grown vintages before proceeding to the cellar checkout.
          </p>
        </header>
        
        <div className="w-full bg-card rounded-md shadow-md border border-border/40 p-4 md:p-8 transition-all duration-500 ease-in-out">
           <WooCommerceCartBlock />
        </div>
      </div>
    </section>;
}